import script from "./AccountBalanceLimit.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccountBalanceLimit.vue?vue&type=script&setup=true&lang=ts"

import "./AccountBalanceLimit.vue?vue&type=style&index=0&id=2b5d04a5&lang=css"

const __exports__ = script;

export default __exports__